interface TextProps {
  text: string;
  size?: "xs" | "sm" | "base" | "lg";
  upperCase?: boolean;
}

const Text = ({ text, size, upperCase }: TextProps) => (
  <>
    <div className="lc-w-full lc-py-2">
      <div
        className={`lc-text-white lc-text-${size} lc-font-normal lc-font-azo-sans ${
          upperCase ? "lc-uppercase" : ""
        }`}
      >
        {text}
      </div>
    </div>
  </>
);

export default Text;
